import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getHourSlots } from '../../Constant.js'
import axios from 'axios'
import Select from 'react-select'
class DiwaniyaAdd extends React.Component {
  state = {
    item_name_en: '',
    item_desc_en: '',
    item_amount: '',
    item_img: '',
    video_url: '',
    is_active: true,
    item_name_ar: '',
    item_desc_ar: '',
    category_id: '',
    amount_goes_to: 'CLIENT',
    start_time: '',
    end_time: '',
    reference_id: '',

    categoryList: [],
    updating: false,
    Edit: false,
    isData: false,
    diwaniyaDropdownList: [],
    selectedOption: '',
    searchable: '',
    shop_min_hour: '',
    source: 'OWNER',
    store_data: {},
    store_list: [],
  }

  componentDidMount = () => {
    this.getDiwaniyaDropdownList()
    this.getCategories()
  }

  getDiwaniyaDropdownList = async () => {
    await axios
      .get(Constant.getAPI() + `/diwaniya/diwaniya-dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            diwaniyaDropdownList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.getDiwaniya()
      })
  }

  getCategories = async () => {
    await axios
      .get(Constant.getAPI() + `/cruise/list-diwaniya-categories?activeOnly=true`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            categoryList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
    if (event.target.name === 'source') {
      this.getStoreList(event.target.value)
    }
  }

  handleSelectChange = (event) => {
    if (event.value) {
      this.setState({
        ...event,
        reference_id: event.value || '',
        selectedOption: event,
      })
    } else {
      this.setState({
        reference_id: '',
        selectedOption: '',
      })
    }
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }

  getDiwaniya = async () => {
    this.setState({ isloading: true })
    var cruiseId = this.props.boatId

    await axios
      .get(Constant.getAPI() + `/items/list-cruise-diwaniya/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        if (res.data.success) {
          const matchItem = res.data.data.find((itm) => itm.id === this.props.diwaniya_Id)
          if (matchItem) {
            this.setState({
              ...matchItem,
              selectedOption: this.state.diwaniyaDropdownList.find((ele) => ele.value == matchItem.reference_id),
            })
            this.setState({ Edit: true })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addDiwaniya = () => {
    var data = new FormData()
    this.setState({ updating: true })

    var cruiseId = this.props.boatId
    data.append('cruise_id', cruiseId)
    data.append('item_name_en', this.state.item_name_en)
    data.append('item_desc_en', this.state.item_desc_en)
    data.append('item_amount', this.state.item_amount)
    data.append('is_active', this.state.is_active)
    data.append('amount_goes_to', this.state.amount_goes_to)
    data.append('item_desc_ar', this.state.item_desc_ar)
    data.append('item_name_ar', this.state.item_name_ar)
    data.append('category_id', this.state.category_id)
    data.append('item_img', this.state.item_img)
    if (this.state.video_url) data.append('video_url', this.state.video_url)

    if (this.state.start_time) data.append('start_time', this.state.start_time)
    if (this.state.end_time) data.append('end_time', this.state.end_time)
    if (this.state.reference_id) data.append('reference_id', this.state.reference_id)

    if (this.props.diwaniya_Id) {
      this.setState({ isData: true })

      data.append('id', this.props.diwaniya_Id)

      axios
        .put(Constant.getAPI() + `/items/update-diwaniya`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Diwaniya Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/diwaniya-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({ isData: true })

      axios
        .post(Constant.getAPI() + '/items/create-cruise-diwaniya', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Diwaniya Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/diwaniya-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    this.addDiwaniya()
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Diwaniya list</label>
                <div className="col-sm-9">
                  <Select
                    name="reference_id"
                    value={this.state.selectedOption}
                    onChange={this.handleSelectChange}
                    options={this.state.diwaniyaDropdownList}
                  />
                  <div style={{ color: 'red' }}>
                    Select Diwaniya from this list it will automaticaly fill some details from centrlized records
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_name_en"
                    placeholder="Item Name: English"
                    onChange={this.handleChange}
                    value={this.state.item_name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_name_ar"
                    placeholder="Item Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.item_name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="item_desc_en"
                    placeholder="Description: English"
                    onChange={this.handleChange}
                    value={this.state.item_desc_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description : Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="item_desc_ar"
                    placeholder="Description: Arabic"
                    onChange={this.handleChange}
                    value={this.state.item_desc_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Opening time</label>
                <div className="col-sm-9">
                  <select
                    name="start_time"
                    className="form-control"
                    value={this.state.start_time}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Opening time</option>
                    {getHourSlots().map(
                      (itm) =>
                        itm.value != '00:00:00' && (
                          <option value={itm.value === '24:00:00' ? '23:59:59' : itm.value}>{itm.label}</option>
                        )
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Closing time</label>
                <div className="col-sm-9">
                  <select
                    name="end_time"
                    className="form-control"
                    value={this.state.end_time}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Closing time</option>
                    {getHourSlots().map(
                      (itm) =>
                        itm.value != '00:00:00' && (
                          <option value={itm.value === '24:00:00' ? '23:59:59' : itm.value}>{itm.label}</option>
                        )
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="item_amount"
                    placeholder="Amount"
                    onChange={this.handleChange}
                    value={this.state.item_amount}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Amount goes to </label>
                <div className="col-sm-9">
                  <select
                    name="amount_goes_to"
                    className="form-control"
                    value={this.state.amount_goes_to}
                    onChange={this.handleChange}
                  >
                    <option value="CLIENT">CLIENT</option>
                    <option value="OWNER">OWNER </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status </label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false"> InActive </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category</label>
                <div className="col-sm-9">
                  <select
                    name="category_id"
                    className="form-control"
                    value={this.state.category_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Category</option>
                    {this.state.categoryList.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-12"></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Image</div>
                <div className="col-sm-6">
                  {this.state.Edit ? (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.item_img}
                      alt="img"
                      onError={({ currentTarget }) => {
                        currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.item_img}
                      alt="img"
                      onError={({ currentTarget }) => {
                        currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Video</div>
                <div className="col-sm-6">
                  {this.state.video_url ? (
                    <video
                      width="200px"
                      height="150px"
                      controls
                      src={Constant.getImage() + this.state.video_url}
                    />
                  ) : (
                    <div style={{ color: '#999', padding: '10px' }}>No video available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/boatsmaster/${this.props.boatType}/${this.props.boatId}/diwaniya-lists`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn hor-grd btn-grd-inverse offset-1"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DiwaniyaAdd
